import styles from "../../../styles/speech.module.css";
import principal1 from "../../../images/principal1.jpg";
import principal2 from "../../../images/principal2.jpg";
import principal3 from "../../../images/principal3.jpg";

const Speech = () => {
  return (
    <div id="speech" className={styles.speechContainer}>
      <div className={styles.speechHeader}>
        <h3 className={styles.speaker}>Principal Speech</h3>
        <h1 className={styles.speechtitle}>
          EDUCATION IS THE MOST POWERFUL WEAPON
        </h1>
        <p className={styles.speechtext}>
          Our students are talented, hard-working and full of good ideas. We
          encourage and empower them to bring their ideas to life. We believe
          that education is the most powerful weapon which you can use to change
          the world. We strive to provide a nurturing environment that fosters
          creativity, critical thinking, and a love for learning. The task of
          the modern educator is not to cut down jungles, but to irrigate
          deserts.
        </p>
        <em className={styles.signature}>Signature</em>
        <p className={styles.signaturename}>Mr Oladipo R.O </p>
        <p className={styles.signatureposition}>I.G.S Principal</p>
      </div>

      <div className={styles.principalimagewrapper}>
        <img
          className={styles.principalimage1}
          src={principal1}
          alt="Principal"
        />
        <img
          className={styles.principalimage2}
          src={principal2}
          alt="Principal"
        />

        <img
          className={styles.principalimage3}
          src={principal3}
          alt="Principal"
        />
      </div>
    </div>
  );
};

export default Speech;
